import type BaseWidget from "widgets/BaseWidget";

export const EEWDSWidgets: [string, () => Promise<typeof BaseWidget>][] = [
  [
    "WDS_AI_CHAT_WIDGET",
    async () =>
      import("ee/modules/ui-builder/ui/wds/WDSAIChatWidget").then(
        (m) => m.WDSAIChatWidget,
      ),
  ],
];
